import React from "react";
import {
  CAR_PANELS,
  PANEL_STATUS_OPTIONS,
  formatInspectionMeta,
  parseInspectionDescription,
} from "../utils/vehicleInspectionSubmission";

function panelStatusLabel(value) {
  return PANEL_STATUS_OPTIONS.find((o) => o.value === value)?.label || "سالم";
}

function InfoLine({ label, value, className = "" }) {
  return (
    <p className={`flex items-baseline gap-2 text-sm ${className}`}>
      <span className="text-gray-500">{label} </span>
      <span className="font-bold text-navy">{value || "—"}</span>
    </p>
  );
}

export default function VehicleInspectionSheet({
  inspection,
  onRegisterAnother,
  onGoToPanel,
}) {
  const { invoiceNumber, date, time } = formatInspectionMeta(inspection);

  const { customerPhone, notes } = parseInspectionDescription(
    inspection?.description,
  );

  const vehicle = inspection?.vehicle || {};
  const carPanels = inspection?.carPanels || {};

  const inspectorName =
    typeof inspection?.vehicleInspector === "object"
      ? inspection?.vehicleInspector?.name || ""
      : "";

  const inspectorCode =
    typeof inspection?.vehicleInspector === "object"
      ? inspection?.vehicleInspector?.code ||
        inspection?.vehicleInspector?._id ||
        ""
      : typeof inspection?.vehicleInspector === "string"
        ? inspection.vehicleInspector
        : "";

  const handlePrint = () => window.print();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f3f5fa",
        padding: "2rem 1rem",
      }}
      className="print:bg-white print:p-0"
    >
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 0;
            }

            body {
              background: white !important;
            }

            .inspection-page {
              width: 210mm !important;
              height: 297mm !important;
              box-shadow: none !important;
              margin: 0 !important;
            }
          }
        `}
      </style>

      <div
        style={{
          margin: "0 auto",
          width: "100%",
          maxWidth: "42rem",
        }}
      >
        {/* دکمه‌ها */}
        <div className="mb-6 flex flex-wrap gap-3 print:hidden">
          <button
            onClick={handlePrint}
            className="rounded-xl bg-navy px-5 py-2.5 text-sm font-bold text-white"
          >
            🖨 چاپ / ذخیره PDF
          </button>

          {onRegisterAnother && (
            <button
              onClick={onRegisterAnother}
              className="rounded-xl border bg-white px-5 py-2.5 text-sm font-bold text-navy"
            >
              ثبت جدید
            </button>
          )}

          {onGoToPanel && (
            <button
              onClick={onGoToPanel}
              className="rounded-xl bg-navy px-5 py-2.5 text-sm font-bold text-white"
            >
              بازگشت به پنل
            </button>
          )}
        </div>

        {/* صفحه A4 */}
        <div
          className="inspection-page"
          style={{
            width: "210mm",
            minHeight: "297mm",

            backgroundImage: "url('/carimp.jpg')",

            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",

            backgroundColor: "white",

            boxShadow: "0 4px 24px rgba(0,0,0,0.10)",

            margin: "0 auto",

            position: "relative",

            padding: "25mm 15mm",
          }}
        >
          {/* سربرگ */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              direction: "rtl",
            }}
          >
            <div className="mr-[575px] mt-[-75px]">
              <InfoLine
                label=""
                value={invoiceNumber}
                className="text-[8px] mt-[1px] mr-[-4px]"
              />
              <InfoLine label="" value={date} className="mt-4 mr-[-40px]" />
              <InfoLine label="" value={time} className="mt-4 mr-[-40px]" />
            </div>
          </div>

          {/* مشتری */}
          <div className="mb-5">
            <InfoLine
              label=""
              value={customerPhone}
              className="mr-20 mt-[74px]"
            />
          </div>

          <div className="mb-5 grid grid-cols-2 gap-[140px] mr-32 mt-[63px]">
            <InfoLine label="" value={vehicle.name} />
            <InfoLine label="" value={vehicle.color} />

            <InfoLine label="" value={vehicle.engineNumber} className="mt-[-57px] mr-[8px]"/>
            <InfoLine label="" value={vehicle.plateNumber} className="text-[20px] mt-[-57px]"/>


            <InfoLine label="" value={vehicle.vin} className="mt-[-103px] mr-[17px]"/>
          </div>

          {/* کارشناس */}

          <div className="mb-5 grid grid-cols-2 gap-3 mt-[45px] mr-36">
            <InfoLine label="" value={inspectorCode} />

            <InfoLine label="" value={inspectorName} className="mr-28"/>
          </div>

          {/* وضعیت بدنه */}

          <div className="mb-5 grid grid-cols-3 gap-2 mt-16 mr-2">
            {CAR_PANELS.map((panel) => (
              <InfoLine
                key={panel.key}
                label={panel.label}
                value={panelStatusLabel(carPanels[panel.key])}
              />
            ))}
          </div>

          {/* توضیحات */}
          <p className="whitespace-pre-line text-sm leading-8 text-navy mt-[65px]">
            {notes || "—"}
          </p>
        </div>
      </div>
    </div>
  );
}
